module.exports = __webpack_public_path__ + "static/media/noImageUser.3449a1d1.svg";